function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  className: "cls-1",
  d: "M267.47,235.1l48.13,24.56c-24.56,38.48-64,72.2-128.91,72.2-77.94,0-141.4-45.72-161.63-116.42H0V183.21H19.24c-.5-5.75-1-11.57-1-17.32,0-6.24.5-12.49,1-18.24H0V115.42H25.48C45.71,45.22,109.18,0,186.62,0c64.95,0,104.85,33.65,128.91,72.19L267.4,96.75C252,70.28,221.19,50.12,186.62,50.12c-46.21,0-83.69,25.48-100.52,65.44H216v32.23H77c-.5,5.75-1,12-1,18.24,0,5.75.49,11.57,1,17.32H216.08v32.23H85.68C102.5,256,140.05,282,186.69,282,221.33,281.74,252.07,262.08,267.47,235.1Z"
})));

var SvgEuro = function SvgEuro(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 315.6 331.86",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEuro, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/euro.7e646aed.svg";
export { ForwardRef as ReactComponent };